export interface SigninInterface {
  email: string;
  password: string;
}
